import { Link } from 'react-router-dom';
import { ArrowRight, Home } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useSiteContent } from '../context/SiteContentContext';

export default function NotFoundPage() {
  const { language, localizedPath } = useSiteContent();
  
  const content = language === 'bg' ? {
    title: 'Маршрутът не е намерен.',
    subtitle: 'Не успяхме да доставим тази страница,',
    subtitleHighlight: 'но можем да доставим вашия товар.',
    backHome: 'Към началото',
    getQuote: 'Поискай оферта'
  } : {
    title: 'Route not found.',
    subtitle: "We couldn't deliver this page,",
    subtitleHighlight: 'but we can deliver your cargo.',
    backHome: 'Back to Home',
    getQuote: 'Get a Quote'
  };
  
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-20">
      <div className="max-w-2xl mx-auto text-center">
        {/* 404 Text */}
        <h1 className="text-7xl sm:text-8xl md:text-9xl font-extrabold text-slate-200 mb-4">
          404
        </h1>
        
        {/* Main Message */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-900 mb-4">
          {content.title}
        </h2>
        
        {/* Subtitle */}
        <p className="text-lg sm:text-xl text-slate-600 mb-8 max-w-md mx-auto">
          {content.subtitle}
          <br />
          <span className="text-[#C41E3A] font-semibold">{content.subtitleHighlight}</span>
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link to={localizedPath('/')}>
            <Button className="bg-[#C41E3A] hover:bg-[#A01830] text-white px-6 py-3 rounded-full flex items-center gap-2">
              <Home className="w-4 h-4" />
              {content.backHome}
            </Button>
          </Link>
          <Link to={localizedPath('/contact') + '?quote=true'}>
            <Button variant="outline" className="border-2 border-[#C41E3A] text-[#C41E3A] hover:bg-[#C41E3A] hover:text-white px-6 py-3 rounded-full flex items-center gap-2">
              {content.getQuote}
              <ArrowRight className="w-4 h-4" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
}
